import { CreateAllData } from '@/apiError/apiCreate';
import { UpdateAllData } from '@/apiError/apiUpdate';
import { getTodaysDate } from '@/utils/date/TodaysDate';
import CustomSelect from '@/utils/search/Search';
import { Button, Col, DatePicker, Form, Input, Row, Space } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';

const BankReceivesForm = ({
  form,
  referenceId,
  onClose,
  loading,
  from,
  fetchPartyList,
  getAllFieldsData,
  getDealNumber,
  showPartyList = [],
  showDealNumber,
  cashBankData,
  fetchCashBankList,
  refreshTable,
  item,
}) => {
  
  useEffect(() => {
    fetchPartyList();
    fetchCashBankList();
  }, []);

  const handleSubmit = async (values) => {
    const finalValues = {
      date: values.date.format('YYYY-MM-DD'),
      customerId: values.customerId,
      issueNumber: values.issueNumber,
      discount: values.discount,
      amount: values.amount,
      bankId: values.bankId,
      itemIds: values.itemIds,
      aacuratedInterest: values.accuratedInterest,
    };
    try {
      referenceId
        ? await UpdateAllData.updateData(
            from === 'dealClose'
              ? `/loan/deal/close/${referenceId}/`
              : `/loan/bank-receive/${referenceId}/`,
            finalValues,
          )
        : await CreateAllData.createItem(
            from === 'dealClose'
              ? '/loan/deals/close/'
              : '/loan/bank-receives/',
            finalValues,
          );
      refreshTable();
      onClose();
    } finally {
    }
  };
  return (
    <div>
      <Form
        form={form}
        className="username"
        layout="vertical"
        initialValues={{
          date: dayjs(getTodaysDate()),
        }}
        onFinish={handleSubmit}
      >
        <Row gutter={24} justify="space-between">
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Transaction Number" name="transactionNumber">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label="Date"
              name="date"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} justify="space-between">
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label="Bank"
              name="bankId"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <CustomSelect
                onChange={(value) => {
                  getDealNumber(value);
                  form.setFieldsValue({
                    issueNumber: null,
                    itemIds: null,
                    totalDueWithInterest: null,
                    dealAmount: null,
                    interestRate: null,
                    numberOfDays: null,
                    accuratedInterest: null,
                  });
                }}
                options={showPartyList?.map((party) => ({
                  key: party.referenceId,
                  value: party.referenceId,
                  label: party.name,
                }))}
                showAddButton={false}
              />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label={from === 'dealClose' ? 'Deal Number' : 'Issue Number'}
              name="issueNumber"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <CustomSelect
                onChange={(value) => {
                  getAllFieldsData(value);
                  form.setFieldValue('itemIds', null);
                }}
                options={showDealNumber?.map((deal) => ({
                  key: deal.referenceId,
                  value: deal.referenceId,
                  label: deal.issueNumber,
                }))}
                showAddButton={false}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label="Total Due With Interest"
              name="totalDueWithInterest"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Deal Amount" name="dealAmount">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Interest Rate" name="interestRate">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Number of Days" name="numberOfDays">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Accurated Interest" name="accuratedInterest">
              <Input disabled />
            </Form.Item>
          </Col>

          {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Interest Paid" name="interestPaid">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item label="Due Interest" name="dueInterest">
              <Input disabled />
            </Form.Item>
          </Col> */}
        </Row>
        <Row gutter={24}>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label="Discount"
              name="discount"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label={from === 'dealClose' ? 'Receive Amount' : 'Paid Amount'}
              name="amount"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              label="Select Item"
              name="itemIds"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <CustomSelect
                mode="multiple"
                options={item?.map((item) => ({
                  key: item.referenceId,
                  value: item.referenceId,
                  label: item.name,
                }))}
                showAddButton={false}
              />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Space size="large">
            <Button
              htmlType="submit"
              loading={loading}
              className="submit-button"
            >
              {referenceId ? 'Update' : 'Create'}
            </Button>
            <Button className="cancel-button" onClick={onClose}>
              Cancel
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};

export default BankReceivesForm;
